import { atom } from "jotai";
import { Display } from "@/@types/display";

export const displayAtom = atom<Display>({
  breakpoint: "pc",
  type: "mobile",
});
